__turbopack_context__.v({
  "active": "p7aUdq_active",
  "checkmark": "p7aUdq_checkmark",
  "container": "p7aUdq_container",
  "content": "p7aUdq_content",
  "content-wrapper": "p7aUdq_content-wrapper",
  "declineButton": "p7aUdq_declineButton",
  "disclaimer": "p7aUdq_disclaimer",
  "disclaimer-text": "p7aUdq_disclaimer-text",
  "label": "p7aUdq_label",
  "list": "p7aUdq_list",
  "paddingTop": "p7aUdq_paddingTop",
  "price": "p7aUdq_price",
  "promptButton": "p7aUdq_promptButton",
  "save-tag": "p7aUdq_save-tag",
  "title": "p7aUdq_title",
  "title-bar": "p7aUdq_title-bar",
});
